/* eslint-disable no-global-assign */
/* eslint-disable no-restricted-globals */
/* eslint-disable @typescript-eslint/no-this-alias */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import Loader from '../../common/LoadingSpinner';
import actions from '../../../actions';
import InfiniteScroll from '../../common/InfiniteScroll';
import { FRONTEND_SERVER } from '../../../config';
import * as api from '../../../epics/api';
import { uiCategorySettings } from './settings';
import ResolveCaseModal from './ResolveCaseModal';

import { TMeta } from '../../../types';
import history from '../../../history';

type TCase = {
    id: number;
    uuid: any;
    created: string;
    resolved: any;
    updated: string;
    owner: any;
    worker_phone_number: any;
    job_status: any;
    category: string;
    status: string;
    content_type: string;
    object_id: number;
    comments: any[];
};

type TContent = {
    id: number;
    category: string;
    message: string;
    datetime_created: string;
    datetime_created_localtime: string;
    expiration: any;
    object_id: number;
    content_type: string;
    additional_object_id?: number;
    is_sent: any;
    user: number;
    datetime_read: any;
    is_read: boolean;
    case: TCase;
};

type TNotifications = {
    meta: TMeta;
    fetching: boolean;
    content: TContent[];
    show: boolean;
    total_unread_messages: number;
};

type TNotificationsContainerProps = {
    user: any;
    loadNotifications: () => void;
    notificationBanner: any;
    notifications: TNotifications;
};

type TCategories = {
    headerName: string;
    color: string;
    noNotificationsMessage: string;
    subCategories: string[];
    actionText: string;
    fetching: boolean;
    meta: TMeta;
    content: TContent[] | [];
    hasMoreItems: boolean;
};

type TAgentCategories = {
    shiftManagementIssues: TCategories;
    trackingIssues: TCategories;
    freelancerIssues: TCategories;
    clockInOutIssues: TCategories;
};

type TClientCategories = {
    jobsIssues: TCategories;
    operationalIssues: TCategories;
    clockInOutIssues: TCategories;
    feedbackIssues: TCategories;
};

type TNotificationsContainerState = {
    categories: TAgentCategories | TClientCategories;
    isOpenResolveCaseModal: boolean;
    actionedNotification: any;
};

class NotificationsContainer extends Component<
    TNotificationsContainerProps,
    TNotificationsContainerState
> {
    pollNotificationsInterval: NodeJS.Timer;

    constructor(props: TNotificationsContainerProps) {
        super(props);

        const issuesStates = {
            fetching: true,
            meta: { count: 0, next: null as any },
            content: [] as any,
            hasMoreItems: false,
        };

        const agentCategories = {
            shiftManagementIssues: {
                headerName: 'Shift management',
                color: '#2C7CBB',
                noNotificationsMessage: 'No issues regarding jobs fulfilment',
                subCategories: [
                    'shiftmanagement.jobdelegated',
                    'shiftmanagement.jobnotfilled',
                    'shiftmanagement.backupnotused',
                    'shiftmanagement.bookingautomatched',
                    'shiftmanagement.booking_self_cancelled',
                ],
                actionText: 'View',
                ...issuesStates,
            },
            trackingIssues: {
                headerName: 'Tracking issues',
                color: '#ff0000',
                noNotificationsMessage: 'No GPS tracking issues',
                subCategories: [
                    'tracking_issue.gps_disabled',
                    'tracking_issue.late',
                    'tracking_issue.device_offline',
                    'freelancer.booking_removed',
                ],
                actionText: 'View',
                ...issuesStates,
            },
            freelancerIssues: {
                headerName: 'Workers',
                color: '#2eb82e',
                noNotificationsMessage: 'No issues regarding workers',
                subCategories: [
                    'freelancer',
                    'bad_feedback',
                    'freelancer.available_to_neighbouring_offices',
                    'freelancer.dvla_check_expiring',
                    'upcoming_interview',
                ],
                actionText: 'View',
                ...issuesStates,
            },
            clockInOutIssues: {
                headerName: 'Clockin-out issues',
                color: '#ffa64d',
                noNotificationsMessage: 'No clocking-in or clocking-out issues',
                subCategories: [
                    'clocking_issue.clockin_late',
                    'clocking_issue.clockin_far',
                    'clocking_issue.clockout_late',
                    'clocking_issue.clockin_missing',
                ],
                actionText: 'View',
                ...issuesStates,
            },
        };

        const clientCategories = {
            jobsIssues: {
                headerName: 'Jobs notifications',
                color: '#2C7CBB',
                noNotificationsMessage: 'No issues regarding jobs',
                subCategories: [
                    'freelancers_replaced',
                    'client_shiftmanagement.job_cancelled',
                    'client_shiftmanagement.job_changed',
                    'client_job_request_confirmed',
                ],
                actionText: 'View',
                ...issuesStates,
            },
            operationalIssues: {
                headerName: 'Operational notifications',
                color: '#ff0000',
                noNotificationsMessage: 'No operational issues',
                subCategories: ['client_tracking_issue.lateness'],
                actionText: 'View',
                ...issuesStates,
            },
            clockInOutIssues: {
                headerName: 'Clockin-out issues',
                color: '#ffa64d',
                noNotificationsMessage: 'No clocking-in or clocking-out issues',
                subCategories: ['client_clocking.clockout_confirm'],
                actionText: 'Resolve',
                ...issuesStates,
            },
            feedbackIssues: {
                headerName: 'Feedback',
                color: '#2eb82e',
                noNotificationsMessage: 'No issues regarding feedback',
                subCategories: ['client_feedbacks.missing_feedback'],
                actionText: 'Feedback',
                ...issuesStates,
            },
        };

        this.state = {
            categories: props.user.isAgent
                ? { ...agentCategories }
                : { ...clientCategories },
            isOpenResolveCaseModal: false,
            actionedNotification: {},
        };
        this.getMoreData = this.getMoreData.bind(this);
        this.goToUrl = this.goToUrl.bind(this);
    }

    componentDidMount() {
        this.getAllNotificationsByCategory();
        // This is for just loading all notifications for popup modal why not ?
        this.props.loadNotifications();
        // Poll for notifications every 30 sec
        const self = this;
        this.pollNotificationsInterval = setInterval(() => {
            if (!document.hidden) {
                self.getAllNotificationsByCategory();
            }
        }, 30000);
    }

    componentWillUnmount() {
        clearInterval(this.pollNotificationsInterval);
    }

    getAllNotificationsByCategory() {
        const self = this;
        // eslint-disable-next-line guard-for-in, no-restricted-syntax
        for (const category in self.state.categories) {
            api.executeHttpRequest(
                `notifications/?is_read=0&case_status=OP&category=${(
                    self.state.categories[
                        category as keyof (TAgentCategories | TClientCategories)
                    ].subCategories || []
                ).join('&category=')}`,
            ).then(res => {
                self.setState({
                    ...self.state,
                    categories: {
                        ...self.state.categories,
                        [category]: {
                            ...self.state.categories[
                                category as keyof (
                                    | TAgentCategories
                                    | TClientCategories
                                )
                            ],
                            fetching: false,
                            content: res.data.content,
                            hasMoreItems: !!res.data.meta?.next,
                            meta: res.data.meta,
                        },
                    },
                });
            });
        }
    }

    getMoreData(stateName: keyof (TAgentCategories | TClientCategories)) {
        const self = this;

        api.executeHttpRequest(
            self.state.categories[stateName].meta.next,
            'get',
            {},
            false,
        ).then(res => {
            self.setState({
                ...self.state,
                categories: {
                    ...self.state.categories,
                    [stateName]: {
                        ...self.state.categories[stateName],
                        content: [
                            ...self.state.categories[stateName].content,
                            ...res.data.content,
                        ],
                        hasMoreItems: !!res.data.meta?.next,
                        meta: res.data.meta,
                    },
                },
            });
        });
    }

    goToUrl(
        e:
            | React.MouseEvent<HTMLAnchorElement>
            | React.FormEvent<HTMLButtonElement>,
        url: string,
        idToRead: number,
    ) {
        if (url) {
            e.preventDefault();
            const browse = () => {
                if (url.startsWith(FRONTEND_SERVER)) {
                    history.push(url.replace(FRONTEND_SERVER, ''));
                    return false;
                }
                window.location.href = url;

                return true;
            };
            if (idToRead) {
                api.executeHttpRequest(`notifications/${idToRead}/`).then(
                    browse,
                );
            } else {
                return browse();
            }
        }

        return false;
    }

    ignoreCase(
        stateName: keyof (TAgentCategories | TClientCategories),
        index: number,
        notification: TContent,
    ) {
        const self = this;
        let currentContent;
        api.executeHttpRequest(`notifications/${notification.id}/`).then(
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            res => {
                currentContent = self.state.categories[stateName].content;
                const filteredContent = currentContent.filter(
                    (content, i) => i !== index,
                );
                self.setState({
                    categories: {
                        ...self.state.categories,
                        [stateName]: {
                            ...self.state.categories[stateName],
                            content: [...filteredContent],
                        },
                    },
                });
            },
        );
    }

    updateCaseStatus = (
        stateName: keyof (TAgentCategories | TClientCategories),
        index: number,
        status: string,
        notification: TContent,
        comment = null as any,
    ) => {
        const self = this;
        let data = {};
        if (comment) {
            data = {
                resolution: comment,
            };
        }

        api.executeHttpRequest(
            `notifications/${notification.id}/${status}/`,
            'post',
            data,
        )
            .then(res => {
                const currentContent = [
                    ...self.state.categories[stateName].content,
                ];
                if (res.data.content.case.status === 'CL') {
                    currentContent.splice(index, 1);
                    self.props.notificationBanner.success(
                        'Resolved',
                        'Case is now closed.',
                    );
                }
                self.setState({
                    categories: {
                        ...self.state.categories,
                        [stateName]: {
                            ...self.state.categories[stateName],
                            content: [...currentContent],
                        },
                    },
                });
                self.closeResolveCaseModal();
            })
            .catch(error => {
                if (error) {
                    const errorMessage =
                        error && error.response && error.response.meta.detail
                            ? error.response.meta.detail
                            : 'Sorry, something went wrong.';
                    self.props.notificationBanner.error(
                        'Error Could not update status.',
                        `${errorMessage}`,
                    );
                }
            });
    };

    handleResolveOnChange(
        event: React.ChangeEvent<HTMLSelectElement>,
        stateName: keyof (TAgentCategories | TClientCategories),
        index: number,
        notification: TContent,
    ) {
        const self = this;
        if (event.target.value === 'ignore') {
            self.ignoreCase(stateName, index, notification);
        } else if (event.target.value === 'resolve') {
            self.updateCaseStatus(stateName, index, 'close', notification);
        } else {
            self.setState({
                actionedNotification: {
                    stateName,
                    index,
                    notification,
                },
            });
            this.openResolveCaseModal();
        }
    }

    openResolveCaseModal() {
        this.setState({ isOpenResolveCaseModal: true });
    }

    closeResolveCaseModal = () => {
        this.setState({ isOpenResolveCaseModal: false });
    };

    getCaseStatus(statusCode: string) {
        if (statusCode === 'OP') {
            return 'Open';
        }
        return 'Closed';
    }

    renderNotificationsList = (
        stateName: keyof (TAgentCategories | TClientCategories),
    ) => {
        const notifications = this.state.categories[stateName].content;

        return notifications.length !== 0 ? (
            <ul>
                {notifications.map((notification: TContent, index) => {
                    let notificationSettings;
                    let url: string;
                    const borderStyle = {} as any;
                    try {
                        notificationSettings =
                            uiCategorySettings[
                                notification.category as keyof typeof uiCategorySettings
                            ];
                        url = notificationSettings.url.replace(
                            /%s/g,
                            // @ts-ignore
                            notification[notificationSettings.pkName],
                        );
                        borderStyle.borderLeftColor =
                            notificationSettings.color;
                        // eslint-disable-next-line no-empty
                    } catch (e) {}
                    return (
                        <li key={notification.id}>
                            <div
                                className={`content ${
                                    !notification.datetime_read ? 'unread' : ''
                                }`}
                                style={borderStyle}
                            >
                                <a
                                    className="info"
                                    href={url}
                                    onClick={e =>
                                        this.goToUrl(
                                            e,
                                            url,
                                            !this.props.user.isAgent ||
                                                !notification.case
                                                ? notification.id
                                                : null,
                                        )
                                    }
                                >
                                    <span>{notification.message}</span>
                                    <span
                                        className="timestamp"
                                        title={moment(
                                            notification.datetime_created,
                                        ).format('L LT')}
                                    >
                                        {notification.case.owner ? (
                                            <span>
                                                Assigned to{' '}
                                                {
                                                    notification.case.owner
                                                        .full_name
                                                }
                                            </span>
                                        ) : (
                                            <span>
                                                {this.getCaseStatus(
                                                    notification.case.status,
                                                )}
                                            </span>
                                        )}
                                        ,{' '}
                                        {moment(
                                            notification.datetime_created,
                                        ).fromNow()}
                                    </span>
                                </a>
                                {notification.case ? (
                                    <div
                                        className={
                                            !this.props.user.isAgent
                                                ? 'actions'
                                                : 'actions-client'
                                        }
                                    >
                                        {this.props.user.isAgent ? (
                                            <select
                                                className="resolve-select"
                                                onChange={e =>
                                                    this.handleResolveOnChange(
                                                        e,
                                                        stateName,
                                                        index,
                                                        notification,
                                                    )
                                                }
                                                value="N/A"
                                            >
                                                <option
                                                    value="N/A"
                                                    disabled={true}
                                                >
                                                    Resolve{'\u2026'}
                                                </option>
                                                <option value="resolve">
                                                    Resolve
                                                </option>
                                                <option value="comment">
                                                    Resolve with comment
                                                    {'\u2026'}
                                                </option>
                                                <option value="ignore">
                                                    Dismiss case
                                                </option>
                                            </select>
                                        ) : null}
                                        {this.props.user.isClient ? (
                                            <button
                                                className="btn"
                                                type="button"
                                                onClick={e =>
                                                    this.goToUrl(
                                                        e,
                                                        url,
                                                        notification.id,
                                                    )
                                                }
                                            >
                                                {
                                                    this.state.categories[
                                                        stateName
                                                    ].actionText
                                                }
                                            </button>
                                        ) : null}
                                        {this.props.user.isClient ? (
                                            <button
                                                className="btn"
                                                type="button"
                                                onClick={() =>
                                                    this.ignoreCase(
                                                        stateName,
                                                        index,
                                                        notification,
                                                    )
                                                }
                                            >
                                                Dismiss
                                            </button>
                                        ) : null}
                                    </div>
                                ) : null}
                            </div>
                        </li>
                    );
                })}
            </ul>
        ) : (
            <div>
                <p className="no-notifications">
                    {this.state.categories[stateName].noNotificationsMessage}
                </p>
            </div>
        );
    };

    render() {
        const self = this;
        return (
            <div className="notificationsContainer">
                <ResolveCaseModal
                    isOpen={this.state.isOpenResolveCaseModal}
                    onRequestClose={this.closeResolveCaseModal}
                    actioned={this.state.actionedNotification}
                    updateCaseStatus={this.updateCaseStatus}
                />
                {Object.keys(self.state.categories).map(
                    (
                        category: keyof (TAgentCategories | TClientCategories),
                        index,
                    ) => (
                        // eslint-disable-next-line react/no-array-index-key
                        <div className="box" key={index}>
                            {self.state.categories[category].meta?.count >=
                                1 && (
                                <span className="badge">
                                    {
                                        self.state.categories[category].meta
                                            ?.count
                                    }
                                </span>
                            )}
                            <div className="header">
                                <p>
                                    {self.state.categories[category].headerName}
                                </p>
                            </div>
                            <div className="inner">
                                {self.state.categories[category].fetching &&
                                !self.state.categories[category].content
                                    .length ? (
                                    <Loader color="gray" />
                                ) : (
                                    <InfiniteScroll
                                        pageStart={1}
                                        loadMore={() =>
                                            self.getMoreData(category)
                                        }
                                        initialLoad={false}
                                        hasMore={
                                            self.state.categories[category]
                                                .hasMoreItems
                                        }
                                        loader={<Loader color="gray" />}
                                    >
                                        {self.renderNotificationsList(category)}
                                    </InfiniteScroll>
                                )}
                            </div>
                        </div>
                    ),
                )}
            </div>
        );
    }
}

const mapStateToProps = (state: { notifications: any; user: any }) => ({
    notifications: state.notifications,
    user: state.user,
});

const mapDispatchToProps = (
    dispatch: (arg0: { type: any; payload: any }) => any,
) => ({
    loadNotifications: () => dispatch(actions.loadNotifications({})),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(NotificationsContainer);
